// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__KtlYQ","inputs":"Stand_inputs__Aeak8","buttons":"Stand_buttons__Nk8Uu","checkboxes":"Stand_checkboxes__NwFb6"};